import { FeatureFlags } from '../../ts/FeatureFlags';
import { Module } from '../../ts/Module';
import { BrowserTitleService } from '../../ts/services/BrowserTitleService';
import { ServerService } from '../../ts/services/ServerService';
import { ISettingsTabsCtrlScope } from '../directives/tbSettingsCoordinator';

export class ServerSettingsTabsCtrl {

  public static $inject = [
    '$scope',
    'BrowserTitleService',
    'ServerService'
  ];

  constructor(
    $scope: ISettingsTabsCtrlScope,
    BrowserTitleService: BrowserTitleService,
    server: ServerService
  ) {
    BrowserTitleService.setTitleWithPlace({translatablePlaceName: 'serverSettings_general'});

    $scope.server = server;
    $scope.hideNameAndId = !server.isSessionMultiSite();
    $scope.extensionsSettingsTabEnabled = FeatureFlags.extensionsSettingsTabEnabled;
    $scope.showEncryptionStatus = true;
  }
}

Module.instance().controller('ServerSettingsTabsCtrl', ServerSettingsTabsCtrl);
